import getConfig from "next/config";
import { UserLocation } from "@themuse/design-system";

import { axiosClient } from "utils/axiosClient";
import { JobLocation } from "interfaces/api/apiInterfaces";

export interface CarmenData {
    city?: string;
    region?: string;
    country: string;
    dma?: string;
    lat: number;
    lon: number;
    // eslint-disable-next-line camelcase
    accuracy_radius: number;
}

/**
 * Get data from Carmen using requesters ip address by default
 * @param ip optional IP address to lookup
 */
export const getCarmenData = async (ip?: string): Promise<UserLocation | void> => {
    const { publicRuntimeConfig: { apiRequestTimeoutMs, carmenApiHost } } = getConfig();
    const suffix = ip ? `/ip/${ip}` : "/me";
    const carmenUrl = `${carmenApiHost}${suffix}`;
    const response = await axiosClient.get<UserLocation>(carmenUrl, { timeout: apiRequestTimeoutMs });
    return (response as any).data;
};

export const locationIsRemote = (location: JobLocation) => ["Flexible / Remote", "Remote / Flexible"]
    .map((a) => a.toLowerCase()).includes(location?.value.toLowerCase());
